"use client";
import * as React from 'react';

type Props = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: 'default' | 'primary' | 'destructive' | 'outline';
  size?: 'sm' | 'md';
};

export function Button({ className = '', variant = 'default', size = 'md', ...rest }: Props) {
  const cls = [
    'admin-btn',
    variant === 'primary' ? 'primary' : '',
    variant === 'destructive' ? 'destructive' : '',
    size === 'sm' ? 'h-8 px-2' : '',
    className,
  ].filter(Boolean).join(' ');
  return <button className={cls} {...rest} />;
}

export default Button;

